import { useTrtcChatStore } from '@/app/stores/useTrtcChatStore';

export function ChatUnreadBadge({
  className,
  collapsedClassName,
  expanded = true,
}: {
  className?: string;
  collapsedClassName?: string;
  expanded?: boolean;
}) {
  const totalUnreadCount = useTrtcChatStore((s) => s.totalUnreadCount);
  const approvalUnreadCount = useTrtcChatStore((s) => s.approvalUnreadCount);

  const total = totalUnreadCount + approvalUnreadCount;
  if (total <= 0) return null;

  const displayCount = total > 99 ? '99+' : total;

  return (
    <span
      className={`bg-red-500 h-4 min-w-4 px-1 flex items-center justify-center text-[10px] font-medium text-font-reverse rounded-full ${expanded ? className : collapsedClassName}`}
    >
      {displayCount}
    </span>
  );
}
